import {onInViewport} from '../../../utils/onInViewport';

export const initIconCards = () => {
	document.querySelectorAll( 'section.cds2-icon-cards, main > section.icons-list' ).forEach( ( component ) => {
		const isAnimated = component.getAttribute( 'data-animated' ) === 'yes';
		
		if ( isAnimated )
		{
			const onWindowScroll = onInViewport( component, () => window.removeEventListener(`scroll`, onWindowScroll ));
			
			window.addEventListener( 'scroll', onWindowScroll );
			
			onWindowScroll();
		}
	})
}
